<template>
    <div class="panel panel-info">
        <!-- Default panel contents -->
        <div class="panel-heading">
            <i class="fa fa-info-circle" aria-hidden="true"></i> STATUS DO FTTH
        </div>

        <div class="panel-body" v-if="ftth">
            <div>
                <div class="row">
                    <div class="col-sm-3">
                        <label for="onu_mac" class="control-label">ONU MAC:</label>
                        <input
                            type="text"
                            v-model="ftth.onu_mac"
                            class="form-control"
                            id="onu_mac"/>
                    </div>

                    <div class="col-sm-3">
                        <label class="control-label">&nbsp;</label>
                        <button
                            @click="save()"
                            class="btn btn-default btn-block btn-success"
                            type="button"
                        >
                            SALVAR ONU
                        </button>
                    </div>

                    <div
                        class="col-sm-6"
                        style="text-align: right; margin-bottom: 15px"
                    >
                        <label class="control-label">&nbsp;</label>
                        <button class="btn btn-danger" @click="remover()">
                            <span class="fa fa-trash"></span> REMOVER
                        </button>
                    </div>

                </div>
                <hr>
                <br/>
                <div class="row">

                    <div class="col-sm-3" style="margin-top: 3px">
                        <button
                            class="btn btn-block btn-success"
                            :disabled="buscando"
                            @click="buscar()"
                        >
                            <span class="fa fa-sync-alt"></span> ATUALIZAR
                        </button>
                    </div>
                    <div class="col-sm-5">
                        <blockquote class="blockquote danger" v-if="buscando">
                            <span class="fa fa-sync-alt"></span> Atualizando
                        </blockquote>
                    </div>
                    <div class="col-sm-4">
                        <blockquote class="blockquote-reverse">
                            CAIXA ONLINE:
                            <b>
                                <span v-if="ftth.online" class="text-success"
                                    >SIM</span
                                >
                                <span v-else class="text-danger">NÃO</span>
                            </b>
                        </blockquote>
                    </div>
                </div>

                <br />
                <div class="row" v-if="ftth.onu">
                    <div class="col-sm-3">
                        <label for="temperature" class="control-label"
                            >TEMPERATURA</label
                        >
                        <input
                            id="temperature"
                            disabled
                            type="text"
                            :value="
                                ftth.onu.temperature.value +
                                    ' ' +
                                    ftth.onu.temperature.unit
                            "
                            class="form-control"
                        />
                    </div>

                    <div class="col-sm-3">
                        <label for="tx_power" class="control-label"
                            >TX POWER</label
                        >
                        <input
                            id="tx_power"
                            disabled
                            type="text"
                            :value="
                                ftth.onu.tx_power.value +
                                    ' ' +
                                    ftth.onu.tx_power.unit
                            "
                            class="form-control"
                        />
                    </div>

                    <div class="col-sm-3">
                        <label for="rx_power" class="control-label"
                            >RX POWER</label
                        >
                        <input
                            id="rx_power"
                            disabled
                            type="text"
                            :value="
                                ftth.onu.rx_power.value +
                                    ' ' +
                                    ftth.onu.rx_power.unit
                            "
                            class="form-control"
                        />
                    </div>

                    <div class="col-sm-3">
                        <label for="voltage" class="control-label"
                            >VOLTAGEM</label
                        >
                        <input
                            id="voltage"
                            disabled
                            type="text"
                            :value="
                                ftth.onu.voltage.value +
                                    ' ' +
                                    ftth.onu.voltage.unit
                            "
                            class="form-control"
                        />
                    </div>
                </div>

                <slot></slot>
            </div>
        </div>

        <div class="panel-body" v-else>
            <h3 style="padding-left: 20px">
                <i class="fa fa-info-circle" aria-hidden="true"></i> BUSCANDO INFORMAÇÕES DA ONU
            </h3>
        </div>
    </div>
</template>

<script>
import { Fiberhome } from "../../class/fiberhome";
import { Contratos } from "../../class/contratos";

export default {
    name: "StatusDaONU",
    props: {
        ftth: {
            default: null
        },
        id: {
            default: null
        }
    },
    data() {
        return {
            interval: null,
            buscando: false
        };
    },
    beforeMount() {
        this.buscar();
        //this.interval = setInterval(() => this.buscar(), 60000);
    },
    beforeDestroy() {
        //clearInterval(this.interval);
    },
    methods: {
        async remover() {
            await Fiberhome.unregisterFtth(this.id);
            this.$emit("remove");
            alert("Removido");
        },

        async save () {
            await Contratos.saveOnuMac(this.ftth.onu_mac, this.id);
            this.buscar();
            alert("Salvo com sucesso!");
        },

        async buscar() {
            this.buscando = true;
            let res = await Fiberhome.infoFtth(this.id);
            this.ftth = res.payload;
            this.buscando = false;
        }
    }
};
</script>
